import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FuseSplashScreenService {
    private static readonly BOOT_SPLASH_MAX_VISIBLE_MS = 8000;
    private static readonly BOOT_SPLASH_REMOVE_DELAY_MS = 450;
    private static readonly BOOT_SPLASH_HIDE_EVENT = 'fuse-splash-screen-hide';

    private _document = inject(DOCUMENT);
    private _hideTimeoutId: ReturnType<typeof setTimeout> | null = null;
    private _removeTimeoutId: ReturnType<typeof setTimeout> | null = null;
    private _isHidden = false;

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Show the splash screen
     */
    show(): void {
        this._isHidden = false;
        this.clearRemovalTimeout();
        this._document.body.classList.remove('fuse-splash-screen-hidden');
        this.startHideWatchdog();
    }

    /**
     * Hide the splash screen
     */
    hide(): void {
        if (this._isHidden) {
            return;
        }

        this._isHidden = true;
        this.clearHideWatchdog();

        const splashElement = this._document.querySelector('fuse-splash-screen');
        if (splashElement) {
            const hideEvent = this._document.createEvent('Event');
            hideEvent.initEvent(FuseSplashScreenService.BOOT_SPLASH_HIDE_EVENT, false, false);
            splashElement.dispatchEvent(hideEvent);
        }

        this._document.body.classList.add('fuse-splash-screen-hidden');

        this.clearRemovalTimeout();
        this._removeTimeoutId = setTimeout(() => {
            splashElement?.remove();
            this._removeTimeoutId = null;
        }, FuseSplashScreenService.BOOT_SPLASH_REMOVE_DELAY_MS);
    }

    private startHideWatchdog(): void {
        this.clearHideWatchdog();
        this._hideTimeoutId = setTimeout(() => {
            if (!this._isHidden) {
                console.warn('[boot] splash fail-safe timeout reached, forcing hide');
                this.hide();
            }
        }, FuseSplashScreenService.BOOT_SPLASH_MAX_VISIBLE_MS);
    }

    private clearHideWatchdog(): void {
        if (!this._hideTimeoutId) {
            return;
        }

        clearTimeout(this._hideTimeoutId);
        this._hideTimeoutId = null;
    }

    private clearRemovalTimeout(): void {
        if (!this._removeTimeoutId) {
            return;
        }

        clearTimeout(this._removeTimeoutId);
        this._removeTimeoutId = null;
    }
}
